import { render, staticRenderFns } from "./SuplementoTarifaRetorno.vue?vue&type=template&id=d0663a36&scoped=true&"
import script from "./SuplementoTarifaRetorno.vue?vue&type=script&lang=js&"
export * from "./SuplementoTarifaRetorno.vue?vue&type=script&lang=js&"
import style0 from "./SuplementoTarifaRetorno.vue?vue&type=style&index=0&id=d0663a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0663a36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRow,VTextField})
